<template>
  <div class="penalty-points-page">
    <AppBreadcrumb :items="breadcrumbItems" :showBack="true" @back="goBack" />
    
    <div class="page-header">
   
    </div>

    <div class="stats-cards">
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalArticles }}</div>
          <div class="stat-label">{{ $t('finePoints.articlesCount') }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12V8H4V12M20 12L4 12M20 12L22 18H2L4 12M20 12H22M4 12H2M12 8V12" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="12" cy="16" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalParts }}</div>
          <div class="stat-label">{{ $t('finePoints.partsCount') }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H21M6 6V4M18 6V4M5 10H19M7 14H17M9 18H15" stroke="currentColor" stroke-width="1.5"/>
            <rect x="4" y="6" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ maxPoints }}</div>
          <div class="stat-label">{{ $t('finePoints.maxPoints') }}</div>
        </div>
      </div>
    </div>

    <!-- Scrollable articles list - mobile friendly -->
    <div class="articles-wrapper">
      <div class="articles-list">
        <div 
          v-for="article in articles" 
          :key="article.number"
          class="article-card"
          :class="{ expanded: expandedArticle === article.number }"
        >
          <div class="article-header" @click="toggleArticle(article.number)">
            <div class="article-info">
              <span class="article-number" v-html="formatArticleNumber(article.number)"></span>
              <h3 class="article-title">{{ article.title }}</h3>
            </div>
            <div class="expand-icon-wrapper">
              <svg 
                class="expand-icon" 
                :class="{ rotated: expandedArticle === article.number }"
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none"
              >
                <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
          </div>

          <transition name="expand">
            <div v-show="expandedArticle === article.number" class="article-content">
              <div 
                v-for="(part, index) in article.parts" 
                :key="index"
                class="part-item"
                :class="getPartClass(part.points)"
              >
                <div class="part-header">
                  <div class="part-number">
                    <span v-if="article.parts.length > 1">{{ getPartText(index) }}</span>
                    <span v-else>{{ $t('finePoints.mainPart') }}</span>
                  </div>
                  <div class="points-badge" :class="getPointsClass(part.points)">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2L15 8.5L22 9.5L17 14L18.5 21L12 17.5L5.5 21L7 14L2 9.5L9 8.5L12 2Z" fill="currentColor"/>
                    </svg>
                    <span>{{ part.points }} {{ $t('finePoints.point') }}</span>
                  </div>
                </div>
                <p class="part-description">{{ part.description }}</p>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="info-note">
    
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'

export default {
  name: 'PenaltyPointsView',
  components: { AppBreadcrumb },

  data() {
    return {
      expandedArticle: null,
      articles: [
        {
          number: 125,
          title: 'Transport vositalaridan foydalanish qoidalarini buzish',
          parts: [
            {
              points: 0.3,
              description: 'Haydovchilarning tormoz tizimida, rul boshqaruvida yoki ulovchi qurilmada nosozligi boʻlgan yoxud tegishli ruxsatnomasiz qayta jihozlangan transport vositalarini boshqarishi'
            },
            {
              points: 1,
              description: 'Foydalanish belgilangan tartibda man etilgan transport vositalarini, xuddi shuningdek davlat raqam belgisi oʻzboshimchalik bilan yechib olingan transport vositalarini boshqarish'
            }
          ]
        },
        {
          number: 126,
          title: "Koʻzgusimon va (yoki) tusi oʻzgartirilgan (qoraytirilgan) oynali, shuningdek tevarak-atrofni koʻrishni cheklaydigan qoplamali transport vositalaridan foydalanish",
          parts: [
            {
              points: 0.5,
              description: 'Texnik reglamentga muvofiq boʻlmagan koʻzgusimon va (yoki) tusi oʻzgartirilgan (qoraytirilgan) oynali transport vositalaridan, xuddi shuningdek haydovchining oʻrnidan tevarak-atrofni koʻrishni cheklaydigan qoʻshimcha narsalar oʻrnatilgan yoki qoplamalar surtilgan transport vositalaridan foydalanish, bundan oynalar tusini oʻzgartirish (qoraytirish) uchun tegishli ruxsatnoma berilgan transport vositalari mustasno'
            },
            {
              points: 1,
              description: 'Xuddi shunday huquqbuzarlik maʼmuriy jazo chorasi qoʻllanilganidan keyin bir yil davomida takror sodir etilgan boʻlsa'
            }
          ]
        },
        {
          number: 127,
          title: 'Transport vositalarining tovush chiqaruvchi, yorituvchi va boshqa qurilmalaridan foydalanish, ularni oʻrnatish qoidalarini buzish',
          parts: [
            {
              points: 0.2,
              description: 'Tovush signalini sababsiz berish, transport vositalariga uni ishlab chiqargan korxona nazarda tutmagan tovush chiqaruvchi va yorituvchi qurilmalarni oʻrnatish, xuddi shuningdek ularni oʻzgartirib oʻrnatish'
            }
          ]
        },
        {
          number: 1283,
          title: 'Transport vositalari haydovchilarining belgilangan harakat tezligini oshirib yuborishi',
          parts: [
            { points: 0.5, description: 'Belgilangan harakat tezligini soatiga 20 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 1, description: 'Belgilangan harakat tezligini soatiga 20 kilometrdan ortiq, lekin 40 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 1.5, description: 'Belgilangan harakat tezligini soatiga 40 kilometrdan ortiq, lekin 60 kilometrdan koʻp boʻlmagan kattalikda oshirib yuborishi' },
            { points: 2, description: 'Belgilangan harakat tezligini soatiga 60 kilometrdan ortiq kattalikda oshirib yuborishi' }
          ]
        },
        {
          number: 1284,
          title: "Transport vositalari haydovchilarining svetoforning taqiqlovchi signaliga yoki yoʻl harakatini tartibga soluvchining taqiqlovchi ishorasiga boʻysunmasdan toʻxtash chizigʻini bosib kirishi va oʻtishi",
          parts: [
            { points: 1, description: 'Svetoforning taqiqlovchi signaliga yoki yoʻl harakatini tartibga soluvchining taqiqlovchi ishorasiga boʻysunmasdan oʻtishi' }
          ]
        },
        {
          number: 1285,
          title: "Transport vositalari haydovchilarining xalaqit berishi yoki avariya holatini yuzaga keltirishi, yoʻlning qarama-qarshi harakatlanish uchun moʻljallangan tomoniga yoki boʻlagiga chiqishi",
          parts: [
            { points: 0.5, description: "Tezkor va maxsus xizmatlarning koʻk yoki qizil yoxud koʻk va qizil rangli yaltiroq mayoqchani yoqqan holda hamda maxsus tovushli signal bilan yaqinlashib kelayotgan transport vositalari toʻsiqsiz oʻtib ketishi uchun transport vositalari haydovchilari tomonidan xalaqit berish" },
            { points: 1, description: "Yoʻlning qarama-qarshi harakatlanish uchun moʻljallangan tomoniga yoki boʻlagiga yoʻl harakati qoidalarini buzgan holda chiqishi, xuddi shuningdek avariya holati yuzaga kelishiga sabab boʻlgan, yaʼni yoʻl harakatining boshqa qatnashchilarini tezlikni, harakat yoʻnalishini keskin oʻzgartirishga yoki oʻz xavfsizligini yoxud boshqa fuqarolarning xavfsizligini taʼminlash uchun oʻzga choralarni koʻrishga majbur qiluvchi huquqbuzarlikni sodir etishi" }
          ]
        },
        {
          number: 1286,
          title: "Transport vositalari haydovchilarining toʻxtash yoki toʻxtab turish qoidalarini buzishi",
          parts: [
            { points: 0.2, description: "Toʻxtash yoki toʻxtab turish qoidalarini buzishi" }
          ]
        },
        {
          number: 1288,
          title: "Transport vositasida odam tashish qoidalarini buzish",
          parts: [
            { points: 0.3, description: "Odam tashish qoidalarini buzish" },
            { points: 0.5, description: "Avtobus va mikroavtobuslarda ichki ishlar organlarining hamrohligisiz odam tashish, agar ularning hamrohligida odam tashish shart boʻlsa" }
          ]
        },
        {
          number: 1289,
          title: "Transport vositalarini quvib oʻtish qoidalarini buzish",
          parts: [
            { points: 1, description: "Quvib oʻtish qoidalarini buzish" }
          ]
        },
        {
          number: 129,
          title: "Transport vositalari haydovchilarining yoʻl harakati xavfsizligiga tahdid soluvchi guruh boʻlib harakat qilishda qatnashishi",
          parts: [
            { points: 1.5, description: "Yoʻl harakati xavfsizligiga tahdid soluvchi yoki avariya holatini keltirib chiqaruvchi guruh boʻlib harakat qilishda qatnashishi" }
          ]
        },
        {
          number: 130,
          title: "Transport vositalari haydovchilarining temir yoʻlning oʻtish joylaridan oʻtish qoidalarini buzishi",
          parts: [
            { points: 1, description: "Temir yoʻlning oʻtish joylaridan oʻtish qoidalarini buzishi" }
          ]
        },
        {
          number: 137,
          title: "Yoʻl-transport hodisasi yuz bergan joydan ketib qolish",
          parts: [
            { points: 2, description: "Yoʻl-transport hodisasi qatnashchilarining belgilangan qoidalarni buzgan holda hodisa yuz bergan joydan ketib qolishi" }
          ]
        }
      ]
    }
  },

  computed: {
    breadcrumbItems() {
      return [{ label: this.$t('finePoints.breadcrumb') }]
    },

    totalArticles() {
      return this.articles.length
    },

    totalParts() {
      return this.articles.reduce((sum, article) => sum + article.parts.length, 0)
    },

    maxPoints() {
      let max = 0
      this.articles.forEach(article => {
        article.parts.forEach(part => {
          if (part.points > max) max = part.points
        })
      })
      return max
    }
  },

  methods: {
    toggleArticle(number) {
      this.expandedArticle = this.expandedArticle === number ? null : number
    },

    formatArticleNumber(number) {
      // 1283 ni 128³ ko'rinishida chiqarish
      const numStr = number.toString()
      if (numStr.length === 4 && numStr.startsWith('128')) {
        // 1283, 1284, 1285, 1286, 1288, 1289 larni 128³, 128⁴, 128⁵ ko'rinishida chiqarish
        const lastDigit = numStr[3]
        return `${numStr.substring(0, 3)}<sup>${lastDigit}</sup>-modda`
      }
      return `${number}-modda`
    },

    getPartText(index) {
      const texts = [this.$t('finePoints.firstPart'), this.$t('finePoints.secondPart'), this.$t('finePoints.thirdPart'), this.$t('finePoints.fourthPart'), this.$t('finePoints.fifthPart')]
      return texts[index] || `${index + 1}-qism`
    },

    getPointsClass(points) {
      if (points >= 1.5) return 'points-high'
      if (points >= 1) return 'points-medium'
      if (points >= 0.5) return 'points-low'
      return 'points-minimal'
    },

    getPartClass(points) {
      if (points >= 1.5) return 'part-high'
      if (points >= 1) return 'part-medium'
      if (points >= 0.5) return 'part-low'
      return 'part-minimal'
    },

    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.penalty-points-page {
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* Page Header */
.page-header {
  text-align: center;
  padding: 16px 16px 8px 16px;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .page-header {
    padding: 24px 20px 16px 20px;
  }
  .penalty-points-page {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
}

.page-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 4px;
  line-height: 1.3;
}

@media (min-width: 768px) {
  .page-title {
    font-size: 28px;
    margin-bottom: 8px;
  }
}

.page-subtitle {
  font-size: 12px;
  color: var(--text-soft);
}

@media (min-width: 768px) {
  .page-subtitle {
    font-size: 16px;
  }
}

/* Stats Cards */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 0 12px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .stats-cards {
    gap: 20px;
    padding: 0 20px;
    margin-bottom: 24px;
  }
}

.stat-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .stat-card {
    padding: 20px;
    gap: 16px;
    border-radius: 20px;
  }
}

.stat-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 12px;
  color: var(--primary);
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .stat-icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
  }
  
  .stat-icon svg {
    width: 28px;
    height: 28px;
  }
}

.stat-content {
  flex: 1;
  min-width: 0;
}

.stat-value {
  font-size: 20px;
  font-weight: 800;
  color: var(--text);
  line-height: 1;
}

@media (min-width: 768px) {
  .stat-value {
    font-size: 32px;
  }
}

.stat-label {
  font-size: 10px;
  color: var(--text-soft);
  margin-top: 4px;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .stat-label {
    font-size: 14px;
    margin-top: 6px;
  }
}

/* Articles Wrapper - Scrollable */
.articles-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 12px 12px 12px;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
  .articles-wrapper {
    padding: 0 20px 20px 20px;
    overflow-y: visible;
  }
}

/* Custom scrollbar */
.articles-wrapper::-webkit-scrollbar {
  width: 3px;
}

.articles-wrapper::-webkit-scrollbar-track {
  background: var(--border);
  border-radius: 10px;
}

.articles-wrapper::-webkit-scrollbar-thumb {
  background: var(--primary);
  border-radius: 10px;
}

.articles-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 768px) {
  .articles-list {
    gap: 12px;
  }
}

/* Article Card */
.article-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .article-card {
    border-radius: 16px;
  }
}

.article-card.expanded {
  border-color: var(--primary);
}

.article-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
  gap: 12px;
}

@media (min-width: 768px) {
  .article-header {
    padding: 16px 20px;
  }
}

.article-header:active {
  background: rgba(59, 130, 246, 0.05);
}

.article-info {
  flex: 1;
  min-width: 0;
}

.article-number {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary);
  background: rgba(59, 130, 246, 0.1);
  padding: 2px 8px;
  border-radius: 12px;
  margin-bottom: 6px;
}

.article-number sup {
  font-size: 10px;
  vertical-align: super;
  line-height: 1;
}

@media (min-width: 768px) {
  .article-number {
    font-size: 14px;
    padding: 4px 12px;
    margin-bottom: 0;
    margin-right: 12px;
  }
  .article-number sup {
    font-size: 12px;
  }
}

.article-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  margin: 0;
  line-height: 1.4;
}

@media (min-width: 768px) {
  .article-title {
    font-size: 15px;
    display: inline;
  }
}

.expand-icon-wrapper {
  flex-shrink: 0;
}

.expand-icon {
  transition: transform 0.3s ease;
  color: var(--text-soft);
  width: 18px;
  height: 18px;
}

@media (min-width: 768px) {
  .expand-icon {
    width: 20px;
    height: 20px;
  }
}

.expand-icon.rotated {
  transform: rotate(180deg);
}

/* Article Content */
.article-content {
  padding: 0 14px 14px 14px;
  border-top: 1px solid var(--border);
}

@media (min-width: 768px) {
  .article-content {
    padding: 0 20px 20px 20px;
  }
}

/* Expand Transition */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Part Item */
.part-item {
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}

@media (min-width: 768px) {
  .part-item {
    padding: 16px;
    margin-bottom: 12px;
  }
}

.part-item:last-child {
  margin-bottom: 0;
}

.part-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
}

.part-number {
  font-size: 11px;
  font-weight: 600;
  color: var(--text);
}

@media (min-width: 768px) {
  .part-number {
    font-size: 14px;
  }
}

.points-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

@media (min-width: 768px) {
  .points-badge {
    gap: 6px;
    padding: 4px 12px;
    font-size: 14px;
  }
  
  .points-badge svg {
    width: 14px;
    height: 14px;
  }
}

.points-badge.points-high {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.points-badge.points-medium {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.points-badge.points-low {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.points-badge.points-minimal {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.part-description {
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-soft);
  margin: 0;
}

@media (min-width: 768px) {
  .part-description {
    font-size: 14px;
    line-height: 1.6;
  }
}

/* Part border colors */
.part-high {
  border-left: 3px solid #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.part-medium {
  border-left: 3px solid #f59e0b;
  background: rgba(245, 158, 11, 0.05);
}

.part-low {
  border-left: 3px solid #22c55e;
  background: rgba(34, 197, 94, 0.05);
}

.part-minimal {
  border-left: 3px solid #3b82f6;
  background: rgba(59, 130, 246, 0.05);
}

/* Info Note */
.info-note {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 14px;
  margin: 0 12px 16px 12px;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .info-note {
    gap: 12px;
    padding: 16px 20px;
    border-radius: 16px;
    margin: 0 20px 24px 20px;
  }
}

.info-note svg {
  color: var(--primary);
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 2px;
}

@media (min-width: 768px) {
  .info-note svg {
    width: 20px;
    height: 20px;
  }
}

.note-content {
  font-size: 11px;
  line-height: 1.5;
  color: var(--text-soft);
}

@media (min-width: 768px) {
  .note-content {
    font-size: 14px;
  }
}

.note-content strong {
  color: var(--primary);
}

/* Mobile specific optimizations */
@media (max-width: 480px) {
  .stat-card {
    padding: 10px 6px;
  }
  
  .stat-icon {
    width: 32px;
    height: 32px;
  }
  
  .stat-icon svg {
    width: 18px;
    height: 18px;
  }
  
  .stat-value {
    font-size: 18px;
  }
  
  .stat-label {
    font-size: 9px;
  }
  
  .article-header {
    padding: 12px;
  }
  
  .article-number {
    font-size: 10px;
    padding: 2px 6px;
  }
  
  .article-number sup {
    font-size: 8px;
  }
  
  .article-title {
    font-size: 12px;
  }
  
  .part-item {
    padding: 10px;
  }
  
  .part-description {
    font-size: 11px;
  }
}
</style>